import { render, staticRenderFns } from "./reportePreciosEspecialesTratamientos.vue?vue&type=template&id=0131623a&scoped=true"
import script from "./reportePreciosEspecialesTratamientos.vue?vue&type=script&lang=js"
export * from "./reportePreciosEspecialesTratamientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131623a",
  null
  
)

export default component.exports